import { useTranslation } from 'react-i18next';
import CountUp from "react-countup";
import Titlebar001 from 'component/titleBar/titleBar_001';
import NoticeBoard001 from 'component/noticeBoard/noticeBoard_001';
import VisibilitySensor from 'react-visibility-sensor';

import './index.css';

function CountUp002 () {
  const { t } = useTranslation();
  const entryType = [
    {key: 0, end: 9, aniCount: 'aniCount1'},
    {key: 1, end: 2, aniCount: 'aniCount2'},
    {key: 2, end: 7, aniCount: 'aniCount3'},
    {key: 3, end: 4, aniCount: 'aniCount4'},
    {key: 4, end: 1, aniCount: 'aniCount5'},
    {key: 5, end: 2, aniCount: 'aniCount6'},
    {key: 6, end: 7, aniCount: 'aniCount7'},
    {key: 7, end: 8, aniCount: 'aniCount8'}
  ]

  return(
    <div className="count002">
      <div className="count002InBox1">
         <Titlebar001 title={t("TitleBar.title2")} />
      </div>
      <div className="count002InBox2">
        <div className="noticeBox">
         {entryType.map(({key, end, aniCount}) => <CountUp
           start={0}
           end={end}
           duration={20}
           separator=" "
           decimals={0}
           delay={1}
           redraw={true}
           key={key}
        >
          {({ countUpRef, start }) => (
            <VisibilitySensor onChange={start} partialVisibility={true} offset={{ top: 10 }}>
               <div className="countBox002">
                  <span ref={countUpRef} className={aniCount} />
               </div>
            </VisibilitySensor>
          )}
        </CountUp>)}
        </div>
      <NoticeBoard001 />
      </div>
  </div>
  )
}

export default CountUp002
